export enum Size {
    AUTO = "auto",
    "X-Small" = "X-Small",
    Small = "Small",
    Medium = "Medium",
    Large = "Large",
}
